export const GRID_COLS = 12;
export const ROW_HEIGHT = 80;
export const GRID_MARGIN: [number, number] = [16, 16];

export interface WidgetLayoutItem {
  widget_id: string;
  /** unique key within the profile (allows same widget multiple times) */
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface DashboardProfile {
  id: number;
  name: string;
  is_active: boolean;
  widgets: WidgetLayoutItem[];
  created_at?: string;
  updated_at?: string;
}

export type WidgetCategory = 'personal' | 'audit' | 'admin' | 'info';

export interface WidgetSizeConstraints {
  minW: number;
  maxW: number;
  minH: number;
  maxH: number;
}

export interface WidgetDefinition {
  id: string;
  name: string;
  description: string;
  icon: React.ElementType;
  defaultW: number;
  defaultH: number;
  constraints: WidgetSizeConstraints;
  component: React.LazyExoticComponent<React.ComponentType<WidgetComponentProps>>;
  requiredPermission?: string;
  category: WidgetCategory;
}

export interface WidgetComponentProps {
  w: number;
  h: number;
  /** Passt die Kachelhöhe an den Inhalt an, ohne einen inneren Scrollbereich. */
  onPreferredHeight?: (rows: number) => void;
}
